import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-212c0ac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-issue" }
const _hoisted_2 = { style: {"margin-top":"20px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "label-with-status" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "header-issue" }
const _hoisted_7 = { class: "header-issue" }
const _hoisted_8 = { class: "header-issue" }
const _hoisted_9 = { class: "header-issue" }
const _hoisted_10 = { class: "btn-bottom" }

import {
  ImageLossAlert,
  IssueDiagnosis,
  IssueSolutionExecution,
} from "@/types/issueMonitoring.type";
import { ref, onMounted } from "vue";
import { getCamerasConfigurationByStationId } from "@/service/cameraConfiguration.service";
import { getSamplingPointById } from "@/service/samplingpoint.service";
import { Station } from "@/types/station.type";
import { CircleCheck, CircleClose } from "@element-plus/icons-vue";
import { ElNotification, ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import { putImageLossAlert } from "@/service/imagelossalert.service.ts";


export default /*#__PURE__*/_defineComponent({
  props: {
    issue: null,
    diagnosis: null
  },
  emits: ["close", "getIssue"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close"): void;
  (e: "getIssue"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  issue: ImageLossAlert;
  diagnosis: IssueDiagnosis | null;
}

const { t } = useI18n();

const activeName = ref("first");

const cameras = ref<{ label: string; value: string; modele: boolean }[]>([]);
const customer = ref("");
// props copy
const issueCopy = ref<ImageLossAlert>({} as ImageLossAlert);
const diagnosisCopy = ref<IssueDiagnosis>({} as IssueDiagnosis);

// form IssueSolutionExecution
const issueSolutionExecution = ref<IssueSolutionExecution>({} as IssueSolutionExecution);

// - emit




onMounted(async () => {
  issueCopy.value = { ...props.issue };

  diagnosisCopy.value = props.diagnosis ? { ...props.diagnosis } : {};
  issueSolutionExecution.value =
    props.diagnosis && issueSolutionExecution ? { ...props.diagnosis.issueSolutionExecution } : {};

  await getCameras();
});

const beforeLeave = (newName: string, oldName: string) => {
  // Solo controlar cuando intenta ir a la segunda pestaña
  if (newName === "third") {
    const notDiagnosis =
      (!diagnosisCopy.value.diagnosis_automatic && !diagnosisCopy.value.diagnosis_manual) ||
      (!diagnosisCopy.value.solution_proposal_automatic &&
        !diagnosisCopy.value.solution_proposal_manual);

    if (notDiagnosis) {
      ElMessage.warning(
        `${t("warning.notIssue", {
          type: `"${t("label.diagnosis")}"`.toLowerCase(),
        })}`
      );
      return false; // bloquea el cambio
    }
  }
  return true; // permite cambio
};

const getCameras = async () => {
  cameras.value = [];
  if (issueCopy.value.samplingPoint?.id) {
    const samplingPoint = await getSamplingPointById(issueCopy.value.samplingPoint.id);
    if ((samplingPoint.station as Station)?.id) {
      const camerasConfiguration = await getCamerasConfigurationByStationId(
        (samplingPoint.station as Station).id
      );
      camerasConfiguration?.forEach((_) => {
        cameras.value.push({ label: _.camera.code, value: _.camera.code, modele: _.modele });
      });
      customer.value = samplingPoint.container.holder;
    }
  }
};

const saveIssue = async () => {
  issueCopy.value.issueDiagnosis = diagnosisCopy.value;
  if (issueSolutionExecution.value) {
    issueCopy.value.issueDiagnosis.issueSolutionExecution = issueSolutionExecution.value;
  }

  const newIssue = await putImageLossAlert(issueCopy.value);

  if (newIssue) {
    ElNotification.success({
      message: `
    ${t("success.action")} <br/>
    ${t("label.issueId")}: <b>${newIssue.code}</b>
  `,
      offset: 100,
      dangerouslyUseHTMLString: true,
    });
  }

  emit("getIssue");
  cancelIssue();
};

const getClass = (type: string) => {
  return issueCopy.value.origin === "MANUAL" && type === "automatic"
    ? "card-bottom gray"
    : "card-bottom";
};

const cancelIssue = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(_component_el_tabs, {
    modelValue: activeName.value,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((activeName).value = $event)),
    class: "demo-tabs",
    "before-leave": beforeLeave
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tab_pane, {
        label: _ctx.$t('label.mainInfo'),
        name: "first"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, {
            class: "card-bottom",
            shadow: "never"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.mainInfo")), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("label.issueId")) + ": " + _toDisplayString(__props.issue.code ?? "-"), 1)
              ]),
              _createVNode(_component_el_form, {
                ref: "ruleFormRef",
                model: issueCopy.value,
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.samplingPoint'),
                            prop: "samplingPoint.name"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issueCopy.value?.samplingPoint?.name), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.customer')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(customer.value ?? "-"), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.identification'),
                            prop: "origin"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issueCopy.value.origin?.charAt(0).toUpperCase() +
                  issueCopy.value.origin?.slice(1).toLowerCase()), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.responsible'),
                            prop: "responsible"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issueCopy.value?.responsable?.email ?? "-"), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.issueDescription'),
                            prop: "issue.type.name"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issueCopy.value?.type?.name), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.issueDescription'),
                            prop: "issue.subType.name"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issueCopy.value.subType ? issueCopy.value.subType.name : "-"), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.startDate'),
                            prop: "fromDateTime"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issueCopy.value.fromDateTime
                    ? _ctx.$d(
                        new Date(issueCopy.value.fromDateTime.toLocaleString()),
                        "dateTimeNoSecs"
                      ).replace(",", "")
                    : "-"), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      (props?.issueCopy?.endDateTime)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 0,
                            span: 12
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issueCopy.value.endDateTime
                  ? _ctx.$d(new Date(issueCopy.value.endDateTime.toLocaleString()), "dateTimeNoSecs").replace(
                      ",",
                      ""
                    )
                  : "-"), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_col, {
                            key: 1,
                            span: 12
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _ctx.$t('label.endDateTime'),
                                prop: "toDateTime"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: issueCopy.value.endDateTime,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((issueCopy.value.endDateTime) = $event)),
                                    type: "datetime",
                                    format: "YYYY-MM-DD HH:mm",
                                    placeholder: "DD/MM/AAAA hh:mm",
                                    style: {"width":"90%"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "card-bottom",
            gutter: 10
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "never" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.incident_cancellation")), 1),
                      _createVNode(_component_el_form, {
                        ref: "ruleFormRef",
                        model: __props.issue,
                        "label-width": "180px",
                        "label-position": "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, { gutter: 10 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: _ctx.$t('label.statusIssue'),
                                    prop: "statusIssue"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_switch, {
                                        modelValue: issueCopy.value.status,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((issueCopy.value.status) = $event)),
                                        "active-action-icon": _unref(CircleCheck),
                                        "inactive-action-icon": _unref(CircleClose)
                                      }, null, 8, ["modelValue", "active-action-icon", "inactive-action-icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: _ctx.$t('label.note'),
                                    prop: "note"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: issueCopy.value.note,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((issueCopy.value.note) = $event)),
                                        rows: 2,
                                        autosize: { maxRows: 2, minRows: 2 },
                                        maxlength: "100",
                                        "show-word-limit": "",
                                        type: "textarea",
                                        "word-limit-position": "outside"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "never" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.camera")), 1),
                      _createElementVNode("div", _hoisted_2, [
                        (cameras.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createVNode(_component_el_radio_group, {
                                modelValue: issueCopy.value.camera,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((issueCopy.value.camera) = $event)),
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cameras.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_radio_button, {
                                      key: item.value,
                                      label: item.value,
                                      disabled: item.value != issueCopy.value.camera
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_4, [
                                          _createTextVNode(_toDisplayString(item.label) + " ", 1),
                                          (item.modele)
                                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                                key: 0,
                                                color: "#67C23A"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CircleCheck))
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_el_icon, {
                                                key: 1,
                                                color: "#F56C6C"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CircleClose))
                                                ]),
                                                _: 1
                                              }))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "disabled"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("warning.notCameras")), 1))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_tab_pane, {
        label: _ctx.$t('label.diagnosis'),
        name: "second"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, {
            class: _normalizeClass(getClass('automatic')),
            shadow: "never"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                ref: "diagnosisFormRef",
                model: diagnosisCopy.value,
                "label-width": "180px",
                "label-position": "left",
                disabled: issueCopy.value.origin === 'MANUAL'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.diagnosis")) + " " + _toDisplayString(_ctx.$t("label.automatic").toLowerCase()), 1)
                  ]),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.diagnosis'),
                            prop: "diagnosis_automatic"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(diagnosisCopy.value.diagnosis_automatic ?? "-"), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.solution_proposal'),
                            prop: "solution_proposal_automatic"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: diagnosisCopy.value.solution_proposal_automatic,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((diagnosisCopy.value.solution_proposal_automatic) = $event)),
                                maxlength: "150",
                                "show-word-limit": "",
                                type: "textarea",
                                "word-limit-position": "outside"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "disabled"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_card, {
            class: _normalizeClass(getClass('manual')),
            shadow: "never"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                ref: "diagnosisFormRef",
                model: diagnosisCopy.value,
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.diagnosis")) + " " + _toDisplayString(_ctx.$t("label.manual").toLowerCase()), 1),
                    _createVNode(_component_el_switch, {
                      modelValue: diagnosisCopy.value.isManual,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((diagnosisCopy.value.isManual) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.responsible'),
                            prop: "responsible"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(diagnosisCopy.value?.responsable?.email ?? "-"), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.diagnosis'),
                            prop: "samplingPoint"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: diagnosisCopy.value.diagnosis_manual,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((diagnosisCopy.value.diagnosis_manual) = $event)),
                                maxlength: "150",
                                "show-word-limit": "",
                                type: "textarea",
                                "word-limit-position": "outside",
                                disabled: !diagnosisCopy.value.isManual
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.solution_proposal'),
                            prop: "samplingPoint"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: diagnosisCopy.value.solution_proposal_manual,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((diagnosisCopy.value.solution_proposal_manual) = $event)),
                                maxlength: "150",
                                "show-word-limit": "",
                                type: "textarea",
                                "word-limit-position": "outside",
                                disabled: !diagnosisCopy.value.isManual
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_card, {
            class: "card-bottom",
            shadow: "never"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                ref: "diagnosisFormRef",
                model: diagnosisCopy.value,
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.note")), 1)
                  ]),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: diagnosisCopy.value.note,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((diagnosisCopy.value.note) = $event)),
                                maxlength: "100",
                                "show-word-limit": "",
                                type: "textarea",
                                "word-limit-position": "outside"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_tab_pane, {
        label: _ctx.$t('label.solutionExecution'),
        name: "third"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, { shadow: "never" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                ref: "diagnosisFormRef",
                model: issueSolutionExecution.value,
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.diagnosis")) + " " + _toDisplayString(_ctx.$t("label.automatic").toLowerCase()), 1)
                  ]),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.execution'),
                            prop: "execution"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: issueSolutionExecution.value.execution,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((issueSolutionExecution.value.execution) = $event)),
                                maxlength: "150",
                                "show-word-limit": "",
                                type: "textarea",
                                "word-limit-position": "outside"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.note'),
                            prop: "note"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: issueSolutionExecution.value.note,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((issueSolutionExecution.value.note) = $event)),
                                maxlength: "150",
                                "show-word-limit": "",
                                type: "textarea",
                                "word-limit-position": "outside"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { onClick: cancelIssue }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: saveIssue
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})